export const TIME_DIFFERENCE = 'میانگین زمان تایید سفارش';
export const SUCCESS_DATA = 'سفارش‌ موفق';
export const UNSUCCESS_DATA = 'سفارش‌ ناموفق';
